// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6F1u8","shieldImage":"Footer_shieldImage__CAEKr","text":"Footer_text__R54QU"};